import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useDialogStyles from '../useDialogStyles';

export function ExitExistingDialogContent({ saving, savingDraft, close, saveDraft }) {
  const classes = useDialogStyles();

  return (
    <div>
      <div className={classes.closeContainer}>
        <IconButton onClick={close}>
          <CloseIcon style={{ fill: '#cccccc', width: 20, height: 20 }} />
        </IconButton>
      </div>
      <h4 className={classes.dialogHeader}>Changes are not yet live!</h4>
      <p className={classes.dialogDescription}>Your changes are not saved yet.</p>
      <p className={classes.dialogDescription}>
        {`Please navigate to the last page and click 'Update' to ensure all edits to your SEEK Ad are saved.`}
      </p>
      <div className={classes.dialogButtonContainer}>
        <Button
          disableElevation
          className={classes.buttonSecondaryLight}
          onClick={saveDraft}
          style={{ minWidth: 130 }}
        >
          {savingDraft ? <CircularProgress size={20} color="inherit" /> : 'No, save and exit'}
        </Button>
        <Button
          disableElevation
          className={classes.buttonSecondary}
          id="SeekNextStepMultiposterBtn"
          style={{ minWidth: 130 }}
          onClick={close}
          endIcon={saving ? null : <ChevronRightIcon />}
        >
          Continue Editing
        </Button>
      </div>
    </div>
  );
}

ExitExistingDialogContent.propTypes = {
  saving: PropTypes.bool,
  savingDraft: PropTypes.bool,
  close: PropTypes.func,
  saveDraft: PropTypes.func
};

export default ExitExistingDialogContent;
